import React from "react";

const SIZES = {
  small: {
    input: "tw-pl-8 tw-pr-8 tw-py-2",
    iconLeft: "tw-left-2",
    clearRight: "tw-right-2",
  },
  medium: {
    input: "tw-pl-10 tw-pr-10 tw-py-3",
    iconLeft: "tw-left-3",
    clearRight: "tw-right-3",
  },
} as const;

export type SearchBarProps = Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  "type" | "value" | "onChange" | "className" | "size"
> & {
  value: string;
  onValueChange: (value: string) => void;
  className?: string;
  clearAriaLabel?: string;
  size?: keyof typeof SIZES;
};

export const SearchBar = React.forwardRef<HTMLInputElement, SearchBarProps>(
  function SearchInput(
    {
      className,
      placeholder,
      size = "small",
      value,
      onValueChange,
      clearAriaLabel = "Clear search",
      disabled,
      ...rest
    },
    ref
  ) {
    const sizeClasses = SIZES[size];
    return (
      <div className={`tw-relative tw-w-full ${className ?? ""}`.trim()}>
        <i
          className={`material-icons tw-absolute ${sizeClasses.iconLeft} tw-top-1/2 -tw-translate-y-1/2 tw-text-gray-400 tw-pointer-events-none tw-text-lg`}
        >
          search
        </i>
        <input
          ref={ref}
          type="search"
          {...rest}
          value={value}
          onChange={(e) => onValueChange(e.target.value)}
          placeholder={placeholder}
          disabled={disabled}
          className={`tw-w-full tw-border tw-border-gray-300 tw-rounded-md tw-text-sm focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-gray-400 focus:tw-border-transparent ${sizeClasses.input}`.trim()}
        />
        {value ? (
          <button
            type="button"
            onClick={() => onValueChange("")}
            disabled={disabled}
            className={`tw-absolute ${sizeClasses.clearRight} tw-top-1/2 -tw-translate-y-1/2 tw-text-gray-400 hover:tw-text-gray-600 disabled:tw-opacity-50`}
            aria-label={clearAriaLabel}
          >
            <i className="material-icons tw-text-lg">close</i>
          </button>
        ) : null}
      </div>
    );
  }
);
